import makeRequest from "../api/makeRequest";
import url from "../api/urls";
import { RequstMethods } from "../api/requestMethode";

export class CandidateService {
    static async getAll(pageNumber: number, pageSize: number, search: string, approvalFilter: string, deleted = false) {
        const params = `?pageNumber=${pageNumber}&pageSize=${pageSize}&search=${search}&approvalFilter=${approvalFilter}&deleted=${deleted}`;
        return await makeRequest(url.candidates.getAll + params, RequstMethods.GET);
    }

    static async setActive(id: string, isActive: boolean) {
        return await makeRequest(url.candidates.setActive + "/" + id, RequstMethods.PUT, { isActive });
    }

    static async getDetails(id: string) {
        return await makeRequest(url.candidates.getDetails + "/" + id, RequstMethods.GET);
    }

    static async approve(id: string, isApproved: boolean, rejectionReason?: string) {
        return await makeRequest(url.candidates.approve + "/" + id, RequstMethods.PUT, { isApproved, rejectionReason });
    }

    static async edit(id: string, payload: any) {
        return await makeRequest(url.candidates.edit + "/" + id, RequstMethods.PUT, payload);
    }

    static async getExams(id: string) {
        return await makeRequest(url.candidates.getExams + "/" + id, RequstMethods.GET);
    }

    static async getTransactions(id: string) {
        return await makeRequest(url.candidates.getTransactions + "/" + id, RequstMethods.GET);
    }
}
